import { Box, Flex, Stack, Text, VStack } from "@chakra-ui/react";
import { ProductDetails_product_variants } from "@the-volte/svc-core-sdk/lib/queries/gqlTypes/ProductDetails";
import { get, isEmpty } from "lodash";
import React from "react";

import { Checkbox } from "@components/atoms";
import { getProductPrice } from "@components/organisms/AddToCartSection/stockHelpers";
import { formatMoney } from "@utils/format-money";

interface IProps {
  productVariants:
    | (ProductDetails_product_variants | null)[]
    | null
    | undefined;
  setVariantId: (variant_id: string) => void;
  variantId: string;
}

export const ProductVariantSelectorB: React.FC<IProps> = ({
  productVariants,
  setVariantId,
  variantId,
}) => {
  const defaultRentalDayVariant = productVariants?.find((pv) => {
    if (isEmpty(productVariants) || !pv?.rentalDays) return null;

    return (
      pv.rentalDays ===
      Math.min(...productVariants.map((pv2) => pv2?.rentalDays || 0))
    );
  });

  const defaultRentalDayGrossAmount = Number(
    get(defaultRentalDayVariant, "pricing.price.gross.amount", 0)
  );
  const defaultRentalDayBorrowerFee = Number(
    get(defaultRentalDayVariant, "pricing.borrowerFee.gross.amount", 0)
  );
  const defaultRentalDays = Number(
    get(defaultRentalDayVariant, "rentalDays", 0)
  );

  const rentalPriceOfDefaultRentalDayVariant =
    (defaultRentalDayGrossAmount + defaultRentalDayBorrowerFee) /
    defaultRentalDays;

  return (
    <VStack width="100%" alignItems="left">
      {productVariants
        ?.sort((a, b) => (a?.rentalDays || 0) - (b?.rentalDays || 0))
        ?.map((pv, i) => {
          const itemRentDays = pv?.rentalDays || 0;

          const rentalPrice =
            get(pv, "pricing.price.gross.amount", 0) +
            get(pv, "pricing.borrowerFee.gross.amount", 0);
          const rentalPricePerDay = rentalPrice / itemRentDays;
          const rentalSavings =
            rentalPriceOfDefaultRentalDayVariant - rentalPricePerDay;

          // @ts-expect-error
          return pv?.disabled ? (
            <Flex
              key={pv?.id || i}
              direction="row"
              alignItems="center"
              height="30px"
            >
              <Box width="1.5rem">
                <Checkbox
                  name={pv?.name || ""}
                  checked={pv?.id === variantId}
                  onChange={() => setVariantId(pv?.id || "")}
                  disabled
                />
              </Box>

              <Box
                textAlign="left"
                style={{
                  fontSize: "1rem",
                  color: "red",
                }}
              >
                {pv?.name || ""}
                {` (`}Unavailable for this date{`) `}
              </Box>
            </Flex>
          ) : (
            <Flex key={pv?.id} direction="column">
              <Checkbox
                marginBottomValue={0.5}
                name={pv?.name || ""}
                checked={pv?.id === variantId}
                onChange={() => setVariantId(pv?.id || "")}
              >
                <Box
                  textAlign="left"
                  style={{
                    fontSize: "1rem",
                    fontWeight: 600,
                  }}
                >
                  {pv?.name || ""}

                  <Box as="span" sx={{ fontWeight: "normal" }}>
                    {` (`}
                    {getProductPrice(null, pv?.pricing)}
                    {`) `}
                  </Box>
                </Box>
              </Checkbox>

              <Stack
                direction="row"
                alignItems="center"
                fontSize="0.9rem"
                ml={10}
              >
                <Text>
                  {formatMoney(
                    rentalPricePerDay,
                    pv?.pricing?.price?.gross?.currency
                  )}
                  /day
                </Text>

                {rentalSavings > 0 &&
                  pv?.id !== defaultRentalDayVariant?.id && (
                    <Text color="green.500">
                      Save&nbsp;
                      {formatMoney(
                        rentalSavings,
                        pv?.pricing?.price?.gross?.currency
                      )}
                    </Text>
                  )}
              </Stack>
            </Flex>
          );
        })}
    </VStack>
  );
};
